t = require('app/scripts/views/internal/teacup-with-helpers')('checklist_add_menu')

module.exports = t.renderable ({ checklistCards, canAddChecklistCard, canAddChecklistBoard }) ->
  t.form ->
    canAdd = canAddChecklistCard && canAddChecklistBoard
    if !canAdd
      t.span '.js-checklist-limit-exeeded.error', { class: t.classify({ hide: canAdd }) }, ->
        t.format(if !canAddChecklistCard then 'card-limit-exceeded' else 'board-limit-exceeded')
      return
    t.label { for: 'id-checklist' }, ->
      t.format 'title'
    t.input '.js-checklist-title.js-autofocus', { type: 'text', id: 'id-checklist', value: t.l('default-checklist-name'), 'data-default': t.l('default-checklist-name'), dir: 'auto' }

    if checklistCards.length > 0
      t.span ->
        t.label { for: 'js-checklist-copy-source' }, ->
          t.format 'copy-items-from-ellipsis'
        t.select '.js-checklist-copy-source', ->
          t.option { value: '', selected: true }, ->
            t.format 'none'
          for { name, checklists } in checklistCards
            t.optgroup { label: name }, ->
              for { id, name } in checklists
                t.option { value: id }, ->
                  t.text name

    t.input '.primary.wide.confirm.js-add-checklist', { type: 'submit', value: t.l('add') }
